import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import ChangePasswordPage from '@/features/account/profile/change-password';
import { IdentityRouteGuard } from '@/features/account/identity-confirmation';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/perfil/trocar-senha')({
  component: () => (
    <HomeGate>
      <IdentityRouteGuard target="password">
        <ChangePasswordPage />
      </IdentityRouteGuard>
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
